import { render, staticRenderFns } from "./support-poster.vue?vue&type=template&id=2008e18b&scoped=true&"
import script from "./support-poster.vue?vue&type=script&lang=js&"
export * from "./support-poster.vue?vue&type=script&lang=js&"
import style0 from "./support-poster.vue?vue&type=style&index=0&id=2008e18b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008e18b",
  null
  
)

export default component.exports